import { useLive } from '@/lib/live';
import { S05CinematicJourney } from '@/components/journey/S05CinematicJourney';

export const S05LiveJourney = () => {
  const { reducedMotion, state, config } = useLive();
  return <S05CinematicJourney reducedMotion={reducedMotion} state={state} configuredStations={config?.stations} />;
};
